"use strict";

// Copyright 2012-2020 The MathWorks, Inc.

/**
 * Default request mapping used by the RequestManager
 */
define([], function () {
  return {
    'Eval': ['CurrentFolder', 'ListFolder'],
    'Eval:Ping': [],
    // Send nothing else for ping
    'Eval:RunFile': ['UpdateFile', 'CurrentFolder', 'ListFolder'],
    'Eval:MlsPublishPre': ['UpdateFile'],
    'FEval:liveEvalInstrumentCode': [],
    // Request mapping was Workspace -- only used by Old
    // Workspace Browser.
    'Interrupt': [],
    'FEval:GetFigures': ['CurrentFolder', 'ListFolder'],
    'FEval:CloseFigure': ['FEval:GetFigures'],
    'FEval:SelectFigure': ['FEval:GetFigures'],
    'FEval:ResetAxes': ['FEval:GetFigures'],
    'FEval:ResizeFigure': ['FEval:GetFigures'],
    'FEval:AxesInteraction2D': ['FEval:GetFigures'],
    'FEval:AxesInteraction3D': ['FEval:GetFigures'],
    'CurrentUser': ['ServiceRegistry'],
    'RouterLogin': ['ServiceRegistry'],
    'CurrentFolder': ['ListFolder'],
    'MoveFile': ['CurrentFolder'],
    'Variable': [],
    // Request mapping was Workspace -- only used by Old Workspace Browser.
    'CloseFile': ['SaveSession'],
    // save the session if a file is closed
    'UpdateFile': ['SaveSession'],
    // save the session if a file is manually saved
    'SaveSession': ['UpdateFile'],
    // update files when the session is saved
    'SaveSessionState': ['UpdateFile'],
    // update files when the session is saved
    'Logout': ['CloseFile'],
    // close files on logout
    'UpdateShare': ['ListFolder'],
    // trigger a list folder so badge can update,
    'AcquireMatlab': ['ServiceRegistry']
  };
});
//# sourceMappingURL=defaultMessageMapping.js.map
